import { login, requestOTP, submitOTP, signup, forgotPassword, resetPassword } from 'api/auth';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

function useLogin() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(login, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useForgotPassword() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(forgotPassword, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () => enqueueSnackbar('کد فراموشی پسورد برای شماره شما ارسال شد.', { variant: 'success' }),
  });
}
function useResetPassword() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(resetPassword, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () => enqueueSnackbar('رمزعبور شما با موفقیت تغییر یافت.', { variant: 'success' }),
  });
}

function useRequestOTP() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(requestOTP, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () => enqueueSnackbar('کد ورود به شماره شما ارسال شد', { variant: 'success' }),
  });
}

function useSubmitOTP() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(submitOTP, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () => enqueueSnackbar('شما با موفقیت وارد شدید.', { variant: 'success' }),
  });
}

function useSignup() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation(signup, {
    onError: (err) => {
      const errorMessage = err.response?.data?.message || 'خطایی رخ داده است. لطفاً دوباره تلاش کنید.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    },
    onSuccess: () =>
      enqueueSnackbar(
        'پروفایل شما با موفقیت تکمیل شد. اکنون می توانید از امکانات سیستم استفاده کنید.',
        { variant: 'success' }
      ),
  });
}

export { useLogin, useRequestOTP, useSubmitOTP, useSignup, useForgotPassword, useResetPassword };
